import { Stack } from "@mui/material";
import { FullHeightContainer } from "../../Common/views/FullHeightContainer";
import { useProjectContext } from "../hooks/useProjectContext";
import { ProjectQuestionsForm } from "./ProjectQuestionsForm";

export const ProjectQuestionsPage = () => {
  const { project } = useProjectContext();

  if (!project) return null;

  return (
    <FullHeightContainer maxWidth="md">
      <Stack py={5} spacing={3}>
        <ProjectQuestionsForm project={project} />
      </Stack>
    </FullHeightContainer>
  );
};
